///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import LaneMatchFilters from "./LaneMatchFilters";
import PanelStateIndicator from "../PanelStateIndicator";
import { fetchMatchingLanes } from "../../../slices/laneMatchSlice";
import messages from "../../../helpers/messages";
import { NoMatches } from "./NoMatches";
import MatchingGrid from "./MatchingGrid";

export const LaneMatch = ({ bidId, role, division: userDivision, onMount }) => {
  useEffect(onMount, [onMount]);
  const dispatch = useDispatch();
  const {
    matchingLaneRequestLaneId,
    lanesError,
    lanes,
    lanesLoading,
    division
  } = useSelector(state => state.laneMatch);
  const bidPricing = useSelector(state => state.bidPricing);
  const unsavedChanges = lanes?.some(l => l.metaData.laneChanged);
  const truckloadLane = bidPricing.lanes?.find(
    x => x.truckloadLaneId === matchingLaneRequestLaneId
  );
  const loading = bidPricing.lanesLoading || lanesLoading;
  const hasLanes =
    lanes?.filter(l => l.truckloadLaneId !== matchingLaneRequestLaneId)
      ?.length > 0;

  return (
    <div className="lane-match one-whole bg-white pt-8">
      <LaneMatchFilters
        role={role}
        loading={loading}
        truckloadLane={truckloadLane}
        unsavedChanges={unsavedChanges}
        division={division}
      />

      {(lanesError || loading) && (lanes === null || lanes.length === 0) && (
        <div className="box panel">
          <PanelStateIndicator
            iconSize="32px"
            loading={loading}
            error={!loading && lanesError}
            errorMessage={
              messages.sorrySomethingWentWrongPleaseTryAgain.defaultMessage
            }
            handleRefresh={() =>
              dispatch(
                fetchMatchingLanes({
                  truckloadLane,
                  resetLaneMatchFilters: false
                })
              )
            }
          />
        </div>
      )}

      {!hasLanes && !lanesError && !loading && <NoMatches />}

      {lanes !== null && hasLanes && (
        <MatchingGrid
          unsavedChanges={unsavedChanges}
          bidId={bidId}
          role={role}
          division={division}
          userDivision={userDivision}
        />
      )}
    </div>
  );
};

export default LaneMatch;
